(function ($) {

    //fix sticky hover in mobile devices
    if ($(window).width() > 768) {
        $('.thumbs-panel').each(function () {
            $(this).addClass("no-touch");
        });
    }

    // to add ara-lable for thumbs icon group
    var arrayOfLabel = $('.field-rating-message');
    $(arrayOfLabel).each(function (index, value) {
        var id = index + 'group' + 'label';
        $(this).attr('id', id);
        if ($(this).next('div').attr('role') === 'group') {
            $(this).next('div').attr('aria-labelledby', id);
        }
    });

    // Enter key event for thumb up and down
    $('.link-icon').on('keypress', function (e) {
        if (e.which == 13) {
            if ($(this).children('.icon-like-standard').length > 0) {
                var likeButton = $(this).children('.icon-like-standard');
                $(likeButton).toggleClass('icon-like-selected');
                $(likeButton).closest(".thumbs-panel").find(".icon-dislike-standard").removeClass('icon-dislike-selected');
            }
            else if ($(this).children('.icon-dislike-standard').length > 0) {
                var disLikeButton = $(this).children('.icon-dislike-standard');
                $(disLikeButton).toggleClass('icon-dislike-selected');
                $(disLikeButton).closest(".thumbs-panel").find(".icon-like-standard").removeClass('icon-like-selected');
            }
        }
    });

    bindThumbClicks();

    function bindThumbClicks() {
        $('.icon-like-standard')
            .on('click', $(this), function (e) {
                toggleLike(e.target, "icon-like-selected");
                removeLike($(this).closest(".thumbs-panel").find(".icon-dislike-standard"), "icon-dislike-selected");
            });
        $('.icon-dislike-standard')
            .on('click', $(this), function (e) {
                toggleLike(e.target, "icon-dislike-selected");
                removeLike($(this).closest(".thumbs-panel").find(".icon-like-standard"), "icon-like-selected");
            });
    }

    function toggleLike(target, state) {
        $(target).toggleClass(state);
    }

    function removeLike(sibling, state) {
        $(sibling).removeClass(state);
    }

}(window.jQuery));

/*Analytics*/
analytics.eventConfig.push(
    {
        "target": ".component.x00-thumbs-rating",
        "codeId": "x00",
        "events": [
            {
                "eventTarget": "a i.icon-like-standard",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "thumbs rating",
                    "componentId": "x00",
                    "eventType": "thumbs up click",
                    "elementType": "icon",
                    "elementText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": "",
                    "parentItemText": ""
                }
            },
            {
                "eventTarget": "a i.icon-dislike-standard",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentName": "thumbs rating",
                    "componentId": "x00",
                    "eventType": "thumbs down click",
                    "elementType": "icon",
                    "elementText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": "",
                    "parentItemText": ""
                }
            }
        ]
    }
)